
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 2a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V8.69a1 1 0 00-.29-.69l-5.63-5.7a1 1 0 00-.71-.3H7zm.393 1.46a1 1 0 01.056 0h4.301v3.79a2 2 0 002 2h3.8v10.29a1 1 0 01-1 1h-9.1a1 1 0 01-1-1V4.46a1 1 0 01.943-1zm5.857 1.08l3.18 3.21h-2.18a1 1 0 01-1-1V4.54zM11.75 11a.7.7 0 00-.68.7v3.8l-.81-.81a.707.707 0 00-1 1l1.87 1.87a.91.91 0 001.28 0l1.85-1.86a.707.707 0 00-1-1l-.81.81V11.7a.7.7 0 00-.7-.7z"}})])
          )
        }
      }
    